import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Trans, withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';

import {
  AppBar, Avatar, Badge, Button, Menu, MenuItem, Toolbar, Tooltip,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import LogoutIcon from '@material-ui/icons/PowerSettingsNew';

import { ROUTE } from '../../constant';
import Ukmap from '../../assets/images/uk.svg';
import styles from '../../assets/jss/headerStyle';
import frame from '../../assets/images/Frame.svg';
import Russiamap from '../../assets/images/russia.svg';
import Dropdown from '../../helper/subMneuIcon/dropdown';
import SocketService from '../../services/SocketService';
import notificationI from '../../assets/images/Bell.svg';
import frameDark from '../../assets/images/frameDark.svg';
import navigator from '../../assets/images/navigator.svg';
import { AuthService, toasterInstance } from '../../services';
import Brightness2Icon from '../../helper/subMneuIcon/SunIcon';
import NotificationList from '../Notification/NotificationList';
import notificationDark from '../../assets/images/bellDark.svg';
import navigatorDark from '../../assets/images/navigatorDark.svg';
import Person from '../../assets/images/svgIcons/personalSettingsIcon';
import logoBlack from '../../assets/images/dashboard_updateportal_white.svg';
import { getClientList, getNotificationCount, userChangePassword } from '../../actions';

import CModal from '../Utils/CModal';

import UserChangePasswordForm from './UserChangePasswordForm';

class HeaderView extends Component {
  /**
   * function to logout user from application
   */
  static headerViewDoLogoutUser = () => {
    AuthService.signOut();
    window.location.href = ROUTE.ROOT;
  };

  static userProfile = () => (
    window.open('/personal-setting', '_self')
  );

  constructor(props) {
    super(props);
    this.state = {
      dropdownMenu: null,
      languageDropDown: null,
      headerViewVisibleModel: false,
      showHeaderViewFormLoader: false,
      notificationMenu: false,
      notificationCount: 0,
      notificationList: true,
      isFullScreenMode: false,
      // isWhitelistIP: false,
    };

    this.clientId = null;
    this.baseImagePath = `${process.env.REACT_APP_GOOGLE_PUBLIC_BUCKET}${process.env.REACT_APP_USER_IMAGE_PATH}`;
  }

  componentDidMount() {
    const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;
    this.clientId = loginUser.clientId;

    if (this.clientId) {
      const { getClientList: getClientList1 } = this.props;
      getClientList1({ id: this.clientId }).then(() => {
        /* this.setState({
          isWhitelistIP: response && response.length > 0 ? response[0].isWhitelistIP : false,
        }); */
      });
    }

    setTimeout(() => {
      SocketService.connect(this.onSocketNotification);
    }, 10000);
    this.updateHeaderNotification();
  }

  /**
   * handleClose close the dropdown menu
   */

  handleClose = () => {
    this.setState({
      dropdownMenu: null,
    });
  };

  /**
   * handleOpen open the dropdown menu
   */
  handleOpen = (event) => {
    this.setState({
      dropdownMenu: event.currentTarget,
    });
  };

  /**
   * function to change user password
   */
  /* changePasswordHandler = (e) => {
    e.preventDefault();
    this.setState({
      dropDownMenu: null,
      headerViewVisibleModel: true,
    });
  }; */

  /**
   * Change Password Creation
   */
  headerViewChangePassword = (pwdInfo) => {
    this.setState({ showHeaderViewFormLoader: true });
    userChangePassword(pwdInfo).then((res) => {
      this.setState({ showHeaderViewFormLoader: false });
      const headerViewData = res;
      if (headerViewData && headerViewData.data && headerViewData.data.status === 200) {
        toasterInstance(<Trans>{headerViewData.data.message}</Trans>, 2, 'successChangePassword');
        this.setState({
          headerViewVisibleModel: false,
        });
        setTimeout(() => {
          HeaderView.headerViewDoLogoutUser();
        }, 2000);
      } else if (headerViewData && headerViewData.response) {
        if (typeof (headerViewData.response.errors) === 'string') {
          toasterInstance(<Trans>{headerViewData.response.errors}</Trans>, 4, 'failedChangePassword');
        } else {
          headerViewData.data.response.errors.forEach((innerData) => {
            toasterInstance(<Trans>{innerData.msg}</Trans>, 4, 'failedChangePassword');
          });
        }
      }
    })
      .catch(() => {
        toasterInstance(<Trans>TOASTER.SOFTWARE_C_FAIL</Trans>, 4, 'failedChangePassword');
      });
  };

  handleSubmitForm = (formData) => {
    this.headerViewChangePassword(formData);
  };

  /**
   * handle language close dropdown
   */
  handleLanguageClose = (event) => {
    this.setState({
      languageDropDown: null,
    });
    const { changeLanguage } = this.props;
    changeLanguage(event.target.innerText);
  };

  /**
   * handle language open dropdown
   */
  handleLanguageOpen = (event) => {
    this.setState({
      languageDropDown: event.currentTarget,
    });
  };

  updateHeaderNotification = (updateList = true) => {
    getNotificationCount()
      .then((res) => {
        this.setState({ notificationCount: res.count });
        if (updateList) {
          this.setState({ notificationList: false }, () => this.setState({ notificationList: true }));
        }
      })
      .catch(() => this.setState({ notificationCount: 0 }));
  };

  onSocketNotification = (message) => {
    if (message.data === 'NOTIFICATION_UPDATE') {
      this.updateHeaderNotification();
    }
  };

  handleFullScreen = () => {
    const { isFullScreenMode } = this.state;
    const { handle } = this.props;
    if (isFullScreenMode) {
      this.setState({ isFullScreenMode: false });
      handle.exit();
    } else {
      this.setState({ isFullScreenMode: true });
      handle.enter();
    }
  };

  render() {
    const {
      classes,
      logo,
      currentLanguage,
      changeTheme,
    } = this.props;

    const {
      languageDropDown,
      notificationMenu,
      notificationCount,
      notificationList,
      dropdownMenu,
      headerViewVisibleModel,
      showHeaderViewFormLoader,
    } = this.state;

    return (
      <div>
        <AppBar className={classes.headerBar}>
          <Toolbar className={classes.rootToolbar}>

            <div className={logo === 1 ? classes.logoUpDiv : classes.logoUpDivDark}>
              <span className={classes.logoImg}>
                <img width="250" src={logo === 1 ? logoBlack : logo} alt="logo" />
              </span>
            </div>

            <div className={classes.headerRightBlock}>

              <Tooltip title="Change Language">

                <Button onClick={this.handleLanguageOpen.bind(this)} className={classes.languageBt}>
                  {currentLanguage === 'en-US' ? <img src={Ukmap} alt="UK" style={{ marginLeft: '3px' }} />
                    : <img src={Russiamap} alt="Russia" style={{ marginLeft: '3px' }} />}
                  <div className="spanlang">
                    <Dropdown />
                  </div>
                </Button>
              </Tooltip>
              <Tooltip title="Full Screen">
                <Button onClick={this.handleFullScreen}>
                  {logo === 1 ? <img src={frame} alt="Russia" /> : <img src={frameDark} alt="Russia" />}

                </Button>
              </Tooltip>
              <Tooltip title={logo === 1 ? 'Light Mode' : 'Dark Mode'}>
                <Button
                  onClick={changeTheme}
                  className={`${classes.removePaddingTB} ${classes.Brightness2Icon}`}
                >
                  <Brightness2Icon />

                </Button>
              </Tooltip>

              <Menu
                name="languageChange"
                keepMounted
                open={Boolean(languageDropDown)}
                onClick={this.handleLanguageClose}
                anchorEl={languageDropDown}
                className={`${classes.menuDropdown} ${classes.flagDropdown}`}
              >
                <MenuItem name="eng" value="Eng">
                  <img className={classes.flagIcon} src={Ukmap} alt="" />
                  English
                </MenuItem>
                <MenuItem name="ru" value="Ru">
                  <img className={classes.flagIcon} src={Russiamap} alt="" />
                  Russia
                </MenuItem>
              </Menu>

              <Button
                onClick={() => this.setState({ notificationMenu: !notificationMenu })}
              >
                <Badge
                  badgeContent={notificationCount}
                  className={classes.headerNotificationBadge}
                  max={9}
                >
                  <Tooltip title="Notifications">
                    {logo === 1 ? <img src={notificationI} alt="Russia" />
                      : <img src={notificationDark} alt="Russia" />}
                  </Tooltip>
                </Badge>
              </Button>

              <div>
                {notificationList && (
                  <NotificationList
                    updateHeader={this.updateHeaderNotification}
                    notificationMenu={notificationMenu}
                    classes={classes}
                    changeNotificationMenu={(val) => this.setState({ notificationMenu: val })}
                  />
                )}
              </div>

              <Tooltip title="Settings">
                <Button className={classes.profileBtn} onClick={this.handleOpen.bind(this)}>
                  {' '}
                  <Avatar
                    alt="Remy Sharp"
                    src={(sessionStorage.displayImg
                      && sessionStorage.displayImg !== null
                      && sessionStorage.displayImg !== 'null')
                      ? `${this.baseImagePath}${sessionStorage.displayImg}?id=${Math.random() * 100}`
                      : logo === 1 ? navigator
                        : navigatorDark}
                  />

                </Button>
              </Tooltip>

              <Menu
                className={classes.menuDropdown}
                anchorEl={dropdownMenu}
                keepMounted
                open={Boolean(dropdownMenu)}
                onClick={this.handleClose}
              >

                <MenuItem onClick={HeaderView.userProfile}>
                  <Person />
                  <Trans>SETTINGS.PERSONAL_SETTING</Trans>
                </MenuItem>

                <MenuItem onClick={HeaderView.headerViewDoLogoutUser}>
                  <LogoutIcon />
                  <Trans>MENU.LOGOUT</Trans>
                </MenuItem>

              </Menu>

              <CModal
                title="LOGIN.CHANGE_PASSWORD"
                open={headerViewVisibleModel}
                crossIcon
                icon={<EditIcon />}
                headerIcon={<EditIcon />}
                handleClose={() => this.setState({ headerViewVisibleModel: false })}
                adjustModalSize
              >
                <UserChangePasswordForm
                  handleSubmit={this.handleSubmitForm}
                  handleClose={() => this.setState({ headerViewVisibleModel: false })}
                  isLoading={showHeaderViewFormLoader}
                />
              </CModal>

            </div>

          </Toolbar>

        </AppBar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientList: state.clientList && state.clientList.data ? state.clientList.data : [],
  };
}

const mapDispatchToProps = (dispatch) => ({
  getClientList: (object) => dispatch(getClientList(object)),
});

export default withTranslation()(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(HeaderView),
  ),
);
